import React from "react";

import CustomerGrowthChart from "../charts/CustomerGrowthChart";
import ChartCard from "../shared/ChartCard";
import KPICard from "../shared/KPICard";
import KPICardGrid from "../shared/KPICardGrid";
import ProgressBar from "../shared/ProgressBar";

const CustomersTab = ({ data, loading }) => (
  <div className="space-y-6">
    {/* KPI Cards */}
    <KPICardGrid>
      <KPICard
        color="bg-blue-500"
        delta={data.comparison?.customerDelta?.value || ""}
        icon="fas fa-users"
        index={0}
        label="Total Customers"
        loading={loading}
        value={data.customers.total.toLocaleString()}
      />
      <KPICard
        color="bg-green-500"
        icon="fas fa-user-check"
        index={1}
        label="Customer Retention"
        loading={loading}
        value={`${data.customers.retentionRate}%`}
      />
      <KPICard
        color="bg-red-500"
        icon="fas fa-user-minus"
        index={2}
        label="Churn Rate"
        loading={loading}
        value={`${data.customers.churnRate}%`}
      />
    </KPICardGrid>

    {/* Customer Growth Trend */}
    <ChartCard loading={loading} title="Customer Growth Trend">
      <CustomerGrowthChart
        categories={data.customers.growth.categories}
        churned={data.customers.growth.churned}
        height={350}
        newCustomers={data.customers.growth.newCustomers}
      />
    </ChartCard>

    {/* Customer Segments */}
    <ChartCard loading={loading} title="Customer Segments">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
        {/* By Plan Type */}
        <div>
          <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">
            By Plan Type
          </h4>
          <div className="space-y-3">
            {data.customers.byPlan.map((item, index) => (
              <ProgressBar
                color={item.color}
                key={index}
                label={item.label}
                percentage={(item.value / data.customers.total) * 100}
                value={`${item.value} customers`}
              />
            ))}
          </div>
        </div>

        {/* By Region */}
        <div>
          <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">
            By Region
          </h4>
          <div className="space-y-3">
            {data.customers.byRegion.map((item, index) => (
              <ProgressBar
                color={item.color}
                key={index}
                label={item.label}
                percentage={(item.value / data.customers.total) * 100}
                value={`${item.value} customers`}
              />
            ))}
          </div>
        </div>
      </div>
    </ChartCard>
  </div>
);

export default CustomersTab;
